import { render, staticRenderFns } from "./paymentCompleted.vue?vue&type=template&id=1d24f455&scoped=true&"
import script from "./paymentCompleted.vue?vue&type=script&lang=js&"
export * from "./paymentCompleted.vue?vue&type=script&lang=js&"
import style0 from "./paymentCompleted.vue?vue&type=style&index=0&id=1d24f455&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d24f455",
  null
  
)

export default component.exports